import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useInsuranceStrength = (
  strengthId: number | undefined,
): string => {
  const strengths = useAppSelector(referenceSlice.selectInsuranceStrengths);
  const strength = strengths.find((s) => s.insuranceStrengthID === strengthId);
  return strength ? strength.insuranceStrengthName : '';
};
